class BESSAppAccountChangePassword extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.app-change-password');
        if (this.root.length === 0) {
            return;
        }
        this.inputs = {
            currentPassword: getMaterialTextControl('current_password'),
            password1: getMaterialTextControl('password1'),
            password2: getMaterialTextControl('password2'),

        }
        this.failedWarning = $('.app-change-failed');
        this.passwordsDontMatchWarning = $('.app-passwords-dont-match');

        this.changeBtn = this.root.find('.app-change');

        this.form = this.root.find('form');
        this.form.submit(this.#onChangePassword.bind(this));

    }

    #onChangePassword(e) {
        e.preventDefault();
        let currentPassword = this.inputs.currentPassword.val();
        let password = this.inputs.password1.val();
        let confirmPassword = this.inputs.password2.val();
        let passwordsMatch = password === confirmPassword;
        this.passwordsDontMatchWarning.showIf(!passwordsMatch);
        if (passwordsMatch) {
            this.failedWarning.hide();
            this.changeBtn.disableControl();
            this.changeBtn.addClass('app-saving').removeClass('app-saved');

            BESSApp.instance.services.api.auth.updatePassword(
                currentPassword,
                password,
                this.#onChanged.bind(this),
                this.#onChangeFailure.bind(this),
            );
        }
    }

    #onChanged() {
        this.doDelayed(function () {
            this.changeBtn.enableControl();
            this.changeBtn.removeClass('app-saving').addClass('app-saved');
            this.inputs.currentPassword.val('');
            this.inputs.password1.val('');
            this.inputs.password2.val('');
            this.root.find('.with-content').removeClass('with-content');
        }, 1500);
    }

    #onChangeFailure(reason) {
        this.failedWarning.text(reason).showIf(true);
        this.changeBtn.enableControl();
        this.changeBtn.removeClass('app-saving');
        ;
    }
}